<template>
  <div class="NumberInput">
    <span @click="minus" :class="['minus', { ban: num <= min }]">
      <i class="el-icon-minus"></i>
    </span>
    <input
      v-model.number="num"
      type="number"
      :min="min"
      :max="max"
      @blur="blur()"
    />
    <span @click="add" :class="['add', { ban: num >= max }]">
      <i class="el-icon-plus"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99999
    },
    initNum: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      num: this.initNum || this.min
    }
  },
  methods: {
    minus () {
      if (this.num <= this.min) {
        return;
      }
      this.num = Number(this.num) - 1;
    },
    add () {
      if (this.num >= this.max) {
        return;
      }
      this.num = Number(this.num) + 1;
    },
    blur () {
      if (!this.num || this.num < this.min) {
        this.num = this.min;
      } else if (this.num > this.max) {
        this.num = this.max;
      }
    },
  },
  watch: {
    num (newNum) {
      this.$emit('input', Number(newNum));
      this.$emit('changeHandle');
    },
    initNum (newVal) {
      if (newVal !== '' && newVal !== undefined) {
        this.num = Number(newVal);
      }
    }
  },
}
</script>

<style scoped lang="less">
@import '../assets/css/var.less';

.NumberInput {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  width: 120px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  user-select: none;
  overflow: hidden;
  background: #ffffff;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: @brandPrimary;
  }

  span {
    width: 34px;
    height: 36px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475569;
    font-size: 13px;
    background: #f8fafc;
    transition: all 0.15s ease;

    &:hover:not(.ban) {
      background: #eff6ff;
      color: @brandPrimary;
    }

    &.ban {
      cursor: not-allowed;
      color: #cbd5e1;
      background: #f8fafc;
    }
  }

  input {
    border: none;
    border-left: 1px solid #e2e8f0;
    border-right: 1px solid #e2e8f0;
    width: 52px;
    height: 36px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    outline: none;

    /* 隐藏原生数字步进器箭头 */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NumberInput.vue